import { getStorage, ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

async function upload_image_firebase_storage({ path, imageFile }) {
    const storage = getStorage();
    const date = new Date().getTime()

    try {
        const imageRef = ref(storage, 'gs://meal-planner-a4500.appspot.com' + path + `/${date}`);

        const snapshot = await uploadBytesResumable(imageRef, imageFile);

        // Get the download URL
        const downloadURL = await getDownloadURL(snapshot.ref);
        console.log('File available at:', downloadURL);
        return downloadURL;
    } catch (error) {
        console.log(error)
    }
}

export default upload_image_firebase_storage;